// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { PageContent } from '@/components/page-content';
import { CustomerTriageListing } from '@/customer/components/customer-triage-listing';
import {
  TriageCustomerSearchListing,
  getTriageCustomerStatusFromSearch,
  triageCustomerSearchListingSchema,
} from '@/customer/triage-customer-search';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/integrations/triage/customers')({
  component: CustomerTriageRoute,
  validateSearch: triageCustomerSearchListingSchema,
});

function CustomerTriageRoute() {
  const navigate = Route.useNavigate();
  const search = Route.useSearch();

  const searchParameters: TriageCustomerSearchListing = {
    status: search.status,
    page: search.page,
  };

  const currentStatus = getTriageCustomerStatusFromSearch(search.status);

  return (
    <PageContent>
      <CustomerTriageListing
        currentStatus={currentStatus}
        searchParameters={searchParameters}
        navigateFn={navigate}
      />
    </PageContent>
  );
}
